import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { validate } from '../../infrastructure/requests';
import * as routes from '../../infrastructure/routemap';

class Validate extends Component {
    state = {
        error: undefined,
        result: undefined,
    }

    componentDidMount() {
        const { token } = this.props;
        validate(token)
            .then(() => 
                this.setState({ error: undefined, result: true })
            ).catch((error) =>
                this.setState({ error: error.message, result: true }));
    }

    render() {
        return (
            <React.Fragment>
                { this.state.result && !this.state.error  && <Redirect to={routes.login + '?validation=succ'} /> }
                { this.state.result && this.state.error  && <Redirect to={routes.login + '?validation=err'} />}
            </React.Fragment>
        );
    }
}

export default Validate;